// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testpage_content__lXLds {
  margin: 70px auto 0;
  width: 75%;
}

.testpage_header_button__1DcuA {
  display: none;
}

.testpage_rounds__X9lYC {
  margin: 0 auto;
  width: 60%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.testpage_round__gU-g\\+ {
  border: 2px solid white;
  border-radius: 50%;
  background-color: #CCFFD1;
  width: 28px;
  height: 28px;
  margin-right: 9px;
}

.testpage_round_correct__wZVwq {
  border: 2px solid white;
  border-radius: 50%;
  background-color: #2FD414;
  width: 28px;
  height: 28px;
  margin-right: 9px;
}

.testpage_round_incorrect__Pu64O {
  border: 2px solid white;
  border-radius: 50%;
  background-color: #F8521D;
  width: 28px;
  height: 28px;
  margin-right: 9px;
}

.testpage_round_completed__WTe4u {
  background-color: #F3A127;
  border: 2px solid white;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  margin-right: 9px;
}

.testpage_question__Bwpon {
  text-align: center;
  font-family: var(--font-rubik);
  font-size: 32px;
  line-height: 38px;
  color: #CCFFD1;
  font-weight: 500;
  padding: 20px;
  border-radius: 25px;
  background-color: #3DA452;
  border: 2px solid #7EDB88;
  margin-bottom: 28px;
}

.testpage_answer__qxUo3 {
  border: 2px solid #F2FFF4;
  border-radius: 12px;
  font-family: var(--font-rubik);
  font-size: 18px;
  line-height: 22px;
  color: #2F2F2F;
  font-weight: 500;
  padding: 20px 24px;
  background: linear-gradient(to bottom, #AFFFB7 0%, #57D464 60%, #8CED95 100%);
  margin-bottom: 16px;
}

.testpage_answer_active__ayGgD {
  background: linear-gradient(to bottom, #F6E865 0%, #F6E865 10%, #F7931D 70%, #EC8A17 75%, #C86000 100%);
}

.testpage_header_block__RuoZa img {
  width: auto;
}

@media screen and (max-width: 1300px) {
  .testpage_header_button__1DcuA {
    display: block;
  }
}
@media screen and (max-width: 768px) {
  .testpage_content__lXLds {
    margin-top: 58px;
    width: 100%;
  }
  .testpage_rounds__X9lYC {
    width: 80%;
  }
}
@media screen and (max-width: 600px) {
  .testpage_content__lXLds {
    margin-top: 24px;
  }
  .testpage_round_completed__WTe4u {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  .testpage_round__gU-g\\+ {
    margin-right: 6px;
    width: 16px;
    height: 16px;
  }
  .testpage_question__Bwpon {
    border-radius: 12px;
    padding: 12px 16px;
    font-size: 20px;
    line-height: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/tamyr/tests/testpage/testpage.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,cAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,6EAAA;EACA,mBAAA;AACF;;AAEA;EACE,uGAAA;AACF;;AAGE;EACE,WAAA;AAAJ;;AAIA;EACE;IACE,cAAA;EADF;AACF;AAIA;EACE;IACE,gBAAA;IACA,WAAA;EAFF;EAKA;IACE,UAAA;EAHF;AACF;AAMA;EAEE;IACE,gBAAA;EALF;EAQA;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EANF;EASA;IACE,iBAAA;IACA,WAAA;IACA,YAAA;EAPF;EAUA;IACE,mBAAA;IACA,kBAAA;IACA,eAAA;IACA,iBAAA;EARF;AACF","sourcesContent":[".content {\n  margin: 70px auto 0;\n  width: 75%;\n}\n\n.header_button {\n  display: none;\n}\n\n.rounds {\n  margin: 0 auto;\n  width: 60%;\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.round {\n  border: 2px solid white;\n  border-radius: 50%;\n  background-color: #CCFFD1;\n  width: 28px;\n  height: 28px;\n  margin-right: 9px;\n}\n\n.round_correct {\n  border: 2px solid white;\n  border-radius: 50%;\n  background-color: #2FD414;\n  width: 28px;\n  height: 28px;\n  margin-right: 9px;\n}\n\n.round_incorrect {\n  border: 2px solid white;\n  border-radius: 50%;\n  background-color: #F8521D;\n  width: 28px;\n  height: 28px;\n  margin-right: 9px;\n}\n\n.round_completed {\n  background-color: #F3A127;\n  border: 2px solid white;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  margin-right: 9px;\n}\n\n.question {\n  text-align: center;\n  font-family: var(--font-rubik);\n  font-size: 32px;\n  line-height: 38px;\n  color: #CCFFD1;\n  font-weight: 500;\n  padding: 20px;\n  border-radius: 25px;\n  background-color: #3DA452;\n  border: 2px solid #7EDB88;\n  margin-bottom: 28px;\n}\n\n.answer {\n  border: 2px solid #F2FFF4;\n  border-radius: 12px;\n  font-family: var(--font-rubik);\n  font-size: 18px;\n  line-height: 22px;\n  color: #2F2F2F;\n  font-weight: 500;\n  padding: 20px 24px;\n  background: linear-gradient(to bottom, #AFFFB7 0%, #57D464 60%, #8CED95 100%);\n  margin-bottom: 16px;\n}\n\n.answer_active {\n  background: linear-gradient(to bottom, #F6E865 0%, #F6E865 10%, #F7931D 70%, #EC8A17 75%, #C86000 100%);\n}\n\n.header_block {\n  img {\n    width: auto;\n  }\n}\n\n@media screen and (max-width: 1300px) {\n  .header_button {\n    display: block;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .content {\n    margin-top: 58px;\n    width: 100%;\n  }\n\n  .rounds {\n    width: 80%;\n  }\n}\n\n@media screen and (max-width: 600px) {\n\n  .content {\n    margin-top: 24px;\n  }\n\n  .round_completed {\n    width: 16px;\n    height: 16px;\n    margin-right: 6px;\n  }\n\n  .round {\n    margin-right: 6px;\n    width: 16px;\n    height: 16px;\n  }\n\n  .question {\n    border-radius: 12px;\n    padding: 12px 16px;\n    font-size: 20px;\n    line-height: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `testpage_content__lXLds`,
	"header_button": `testpage_header_button__1DcuA`,
	"rounds": `testpage_rounds__X9lYC`,
	"round": `testpage_round__gU-g+`,
	"round_correct": `testpage_round_correct__wZVwq`,
	"round_incorrect": `testpage_round_incorrect__Pu64O`,
	"round_completed": `testpage_round_completed__WTe4u`,
	"question": `testpage_question__Bwpon`,
	"answer": `testpage_answer__qxUo3`,
	"answer_active": `testpage_answer_active__ayGgD`,
	"header_block": `testpage_header_block__RuoZa`
};
export default ___CSS_LOADER_EXPORT___;
